<template>
    <div class="carOwner_mobilebox">
        <top_mobile></top_mobile>
        <div class="fixedcolor"></div>
        <img class="imgfont1" ref="imgfont1s" src="../../public/statics/img/ycz3m.png" alt="">
        <img ref="imgfont2s" class="imgfont2" src="../../public/statics/img/ycz2m.png" alt="">
        <img class="imgfont3" @click="loadandroid()" ref="imgfont3s" src="../../public/statics/img/yhz4m.png" alt="">
        <img class="imgfont4" @click="loadios()" ref="imgfont4s" src="../../public/statics/img/yhz5m.png" alt="">
    </div>


</template>

<script>
    import top_mobile from "../components/top_mobile";
    import { Toast } from "vant";

    export default {
        name: "carOwner_mobile",
        components: {
            top_mobile
        },
        data() {
            return {}
        },
        mounted() {
            let width = this.$refs.imgfont2s.offsetWidth;
            let height = width * 0.32307 * 2;
            this.$refs.imgfont3s.style.top = height + 'px';
            let height1 = height + 150;
            let height2 = height + 130
            this.$refs.imgfont4s.style.top = height1 + 'px';
            this.$refs.imgfont1s.style.bottom = height2 + 'px';
        },
        methods: {
            loadandroid() {
                var u = navigator.userAgent;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                if(isAndroid){
                    window.location.href='https://webcdn.m.qq.com/webapp/homepage/index.html#/appDetail?apkName=com.ocean.supplier&info=01C98BC9A07C0FBB07C87773C4C75B87';
                }else{
                    Toast('请用Andriod设备下载!')
                }

            },
            loadios() {
                var u = navigator.userAgent;
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if(isiOS){
                    window.location.href='https://apps.apple.com/cn/app/%E4%BA%91%E8%BD%A6%E4%B8%BB/id1540907919';
                }else{
                    Toast('请用ios设备下载!')
                }

            },
        },
    }
</script>

<style scoped lang='scss'>
    .carOwner_mobilebox {
        width: 100%;
        height: 100%;
        background-image: url('../../public/statics/img/ycz1m.png');
        background-repeat: no-repeat;
        background-position: center;
        background-attachment: fixed;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        position: relative;
        .fixedcolor{
            width: 100%;
            height: 44px;
            background: #2c3e50;
            position: fixed;
            top: 0;
        }

        .imgbox {
            width: 100%;
            height: auto;
            background: #4f8aff;
            float: left;

        }

        .imgfont1 {
            position: fixed;
            top: 0;
            bottom: 260px;
            left: 0;
            right: 0;
            margin: auto;
            width: 100px;
        }

        .imgfont2 {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            width: 100%;
        }

        .imgfont3 {
            position: fixed;
            top: 200px;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            width: 180px;
        }

        .imgfont4 {
            position: fixed;
            top: 300px;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            width: 180px;
        }
    }
</style>